import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const WeekSettingsLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'WeekSettingsLazy' */ './components/WeekSettings'
		)
);

export default (store) => {
	return {
		path: 'week-settings',
		element: <AsyncLoading component={<WeekSettingsLazy />} />,
	};
};
